import styled from "styled-components";

import { COLORS } from "constants/colorScheme";

export const LinkWrapper = styled.div`
  display: flex;
  min-width: 166px;
  height: 100%;

  && .MuiListItem-root {
    display: flex;
    align-items: center;
    flex-direction: column;

    margin: 0px;
    padding: 0px;

    color: ${COLORS.BLACK_50};
    background-color: ${COLORS.WHITE};
    border-radius: 0;

    &:hover {
      color: ${COLORS.CYAN};
    }
  }

  && .MuiListItem-root.Mui-selected,
  .MuiListItem-root.Mui-selected:hover {
    background-color: ${COLORS.WHITE};
    color: ${COLORS.CYAN};
    border-bottom: 2px solid ${COLORS.CYAN};
  }

  && .MuiListItemText-root {
    display: flex;
    align-items: center;
  }
`;
